// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itinerary-details-page-wrapper .nav-bar-wrapper span {
  font-size: 28px;
  font-weight: 600;
  color: #93288E;
}
.itinerary-details-page-wrapper .itinerary-info-wrapper .itinerary-info-route {
  font-size: 24px;
  font-weight: 600;
  color: #93288E;
}
.itinerary-details-page-wrapper .itinerary-info-wrapper .itinerary-info-details-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 10px;
}
.itinerary-details-page-wrapper .itinerary-info-wrapper .itinerary-info-details-wrapper .itinerary-info-details {
  font-size: 18px;
  font-weight: 400;
  color: #3a3a3a;
}
.itinerary-details-page-wrapper .cruise-overview-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/cruise-overview.webp);
  background-size: 100% 100%;
  border-radius: 26px;
  object-fit: cover;
}
.itinerary-details-page-wrapper .cruise-overview-wrapper p {
  margin: 0;
}
.itinerary-details-page-wrapper .cruise-overview-wrapper p:first-child {
  font-size: 30px;
  font-weight: 700;
}
.itinerary-details-page-wrapper .cruise-overview-wrapper p:last-child {
  font-size: 22px;
  font-weight: 400;
}
.itinerary-details-page-wrapper .itinerary-inclusions-wrapper .itinerary-inclusions-heading {
  font-size: 34px;
  font-weight: 600;
  color: #F16F5B;
}
.itinerary-details-page-wrapper .itinerary-inclusions-wrapper .itinerary-inclusions-lists .itinerary-inclusions-list span {
  font-size: 22px;
  color: #3a3a3a;
}
.itinerary-details-page-wrapper .day-details-wrapper, .itinerary-details-page-wrapper .cruise-activities-wrapper, .itinerary-details-page-wrapper .snorkeling-girl-wrapper {
  background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/magazine-background-image.webp);
  background-size: 100% 100%;
  object-fit: cover;
}
.itinerary-details-page-wrapper .external-links-wrapper {
  background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/cta-magazine-image.webp);
  background-size: 100% 100%;
  object-fit: cover;
}
.itinerary-details-page-wrapper .external-links-wrapper a {
  background: rgba(255, 255, 255, 0.263);
  padding: 10px 16px;
  border-radius: 28px;
  text-decoration: none;
  text-align: center;
}
.itinerary-details-page-wrapper .excursion-details-wrapper .excursion-cards-wrapper .excursion-card-wrapper img {
  width: 100%;
  max-height: 250px;
  object-fit: cover;
}
.itinerary-details-page-wrapper ul {
  list-style-type: circle;
  padding-left: 18px;
}
.itinerary-details-page-wrapper li {
  font-size: 16px;
  font-weight: 400;
  color: #7A7A7A;
  margin-bottom: 4px;
}

@media only screen and (width <= 480px) {
  .itinerary-details-page-wrapper .nav-bar-wrapper {
    flex-direction: column-reverse;
    gap: 16px;
    padding-top: 12px !important;
  }
  .itinerary-details-page-wrapper .cruise-overview-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
  }
  .itinerary-details-page-wrapper .itinerary-inclusions-lists {
    grid-template-columns: 1fr;
  }
  .itinerary-details-page-wrapper .terms-section-wrapper .section-wrapper {
    flex-direction: column;
  }
  .itinerary-details-page-wrapper .terms-section-wrapper .section-wrapper > div {
    width: 100%;
  }
}
@media only screen and (width >= 768px) {
  .itinerary-details-page-wrapper .cruise-activities-wrapper > div:last-child {
    display: flex;
    justify-content: center;
  }
  .itinerary-details-page-wrapper .cruise-activities-wrapper > div:last-child div {
    width: 100%;
    max-width: 262px;
  }
}
@media only screen and (width <= 932px) {
  .itinerary-details-page-wrapper .day-details-wrapper .day-detail {
    flex-direction: column !important;
    gap: 24px;
  }
  .itinerary-details-page-wrapper .day-details-wrapper .day-detail div {
    max-width: 100%;
    align-self: flex-start;
  }
  .itinerary-details-page-wrapper .day-details-wrapper .day-detail img {
    width: 100%;
  }
  .itinerary-details-page-wrapper .day-details-wrapper .sea-detail {
    flex-direction: column-reverse;
    gap: 12px;
  }
  .itinerary-details-page-wrapper .day-details-wrapper .sea-detail div {
    max-width: 100%;
  }
  .itinerary-details-page-wrapper .day-details-wrapper .sea-detail img {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicDetailsPage/style.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AADZ;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAJZ;AAOQ;EACI,aAAA;EACA,2DAAA;EACA,SAAA;AALZ;AAOY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AALhB;AAUI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EAEA,wGAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;AATR;AAWQ;EACI,SAAA;AATZ;AAYQ;EACI,eAAA;EACA,gBAAA;AAVZ;AAaQ;EACI,eAAA;EACA,gBAAA;AAXZ;AAgBQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAdZ;AAmBgB;EACI,eAAA;EACA,cAAA;AAjBpB;AAuBI;EACI,kHAAA;EACA,0BAAA;EACA,iBAAA;AArBR;AAwBI;EACI,2GAAA;EACA,0BAAA;EACA,iBAAA;AAtBR;AAuBQ;EACI,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AArBZ;AA4BgB;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AA1BpB;AAgCI;EACI,uBAAA;EACA,kBAAA;AA9BR;AAiCI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA/BR;;AAmCA;EAEQ;IACI,8BAAA;IACA,SAAA;IACA,4BAAA;EAjCV;EAoCM;IACI,aAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;EAlCV;EAqCM;IACI,0BAAA;EAnCV;EAuCU;IACI,sBAAA;EArCd;EAsCc;IACI,WAAA;EApClB;AACF;AA0CA;EAGY;IACI,aAAA;IACA,uBAAA;EA1Cd;EA2Cc;IACI,WAAA;IACA,gBAAA;EAzClB;AACF;AA+CA;EAGY;IACI,iCAAA;IACA,SAAA;EA/Cd;EAiDc;IACI,eAAA;IACA,sBAAA;EA/ClB;EAkDc;IACI,WAAA;EAhDlB;EAoDU;IACI,8BAAA;IACA,SAAA;EAlDd;EAoDc;IACI,eAAA;EAlDlB;EAqDc;IACI,WAAA;EAnDlB;AACF","sourcesContent":[".itinerary-details-page-wrapper {\n    .nav-bar-wrapper {\n        span {\n            font-size: 28px;\n            font-weight: 600;\n            color: #93288E;\n        }\n    }\n\n    .itinerary-info-wrapper{\n        .itinerary-info-route{\n            font-size: 24px;\n            font-weight: 600;\n            color: #93288E;\n        }\n\n        .itinerary-info-details-wrapper{\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n            gap: 10px;\n\n            .itinerary-info-details{\n                font-size: 18px;\n                font-weight: 400;\n                color: #3a3a3a;\n            }\n        }\n    }\n\n    .cruise-overview-wrapper{\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        padding: 32px;\n\n        background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/cruise-overview.webp);\n        background-size: 100% 100%;\n        border-radius: 26px;\n        object-fit: cover;\n\n        p{\n            margin: 0;\n        }\n\n        p:first-child{\n            font-size: 30px;\n            font-weight: 700;\n        }\n\n        p:last-child{\n            font-size: 22px;\n            font-weight: 400;\n        }\n    }\n\n    .itinerary-inclusions-wrapper{\n        .itinerary-inclusions-heading{\n            font-size: 34px;\n            font-weight: 600;\n            color: #F16F5B;\n        }\n\n        .itinerary-inclusions-lists{\n            .itinerary-inclusions-list{\n                span{\n                    font-size: 22px;\n                    color: #3a3a3a;\n                }\n            }\n        }\n    }\n\n    .day-details-wrapper, .cruise-activities-wrapper, .snorkeling-girl-wrapper{\n        background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/magazine-background-image.webp);\n        background-size: 100% 100%;\n        object-fit: cover;\n    }\n\n    .external-links-wrapper{\n        background-image: url(https://images.cordeliacruises.com/cordelia_v2/public/images/cta-magazine-image.webp);\n        background-size: 100% 100%;\n        object-fit: cover;\n        a{\n            background: rgba(255, 255, 255, 0.263);\n            padding: 10px 16px;\n            border-radius: 28px;\n            text-decoration: none;\n            text-align: center;\n        }\n    }\n\n    .excursion-details-wrapper{\n        .excursion-cards-wrapper{\n            .excursion-card-wrapper{\n                img{\n                    width: 100%;\n                    max-height: 250px;\n                    object-fit: cover;\n                }\n            }\n        }\n    }\n\n    ul {\n        list-style-type: circle;\n        padding-left: 18px;\n    }\n\n    li {\n        font-size: 16px;\n        font-weight: 400;\n        color: #7A7A7A;\n        margin-bottom: 4px;\n    }\n}\n\n@media only screen and (width <= 480px) {\n    .itinerary-details-page-wrapper {\n        .nav-bar-wrapper {\n            flex-direction: column-reverse;\n            gap: 16px;\n            padding-top: 12px!important;\n        }\n\n        .cruise-overview-wrapper{\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            padding: 12px;\n        }\n\n        .itinerary-inclusions-lists{\n            grid-template-columns: 1fr;\n         }\n\n         .terms-section-wrapper{\n            .section-wrapper{\n                flex-direction: column;\n                >div{\n                    width: 100%;\n                }\n            }\n         }\n    }\n}\n\n@media only screen and (width >= 768px) {\n    .itinerary-details-page-wrapper {\n        .cruise-activities-wrapper{\n            >div:last-child{\n                display: flex;\n                justify-content: center;\n                div{\n                    width: 100%;\n                    max-width: 262px;\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (width <= 932px) {\n    .itinerary-details-page-wrapper {\n        .day-details-wrapper{\n            .day-detail{\n                flex-direction: column!important;\n                gap: 24px;\n\n                div{\n                    max-width: 100%;\n                    align-self: flex-start;\n                }\n\n                img{\n                    width: 100%;\n                }\n            }\n\n            .sea-detail{\n                flex-direction: column-reverse;\n                gap: 12px;\n\n                div{\n                    max-width: 100%;\n                }\n\n                img{\n                    width: 100%;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
